'use client';

import {
  HomeLandingSections,
  HomeStoriesSection,
  HomeCommunitySection,
  HomeVoicesSection,
  HomeAboutSection,
  CommunityMatrimonyServices,
} from '@/components/homePageSections';

import { useState } from 'react';
import Header from '@/components/Header';
import HomeHeroSection from '@/components/HomeHeroSection';

const communityServices: { label: string; href?: string }[] = [
  { label: "96 Kuli Maratha Surname List" },
  { label: "96 Kuli Maratha List" },
  { label: "96 Kuli Maratha" },
  { label: "96 Kuli Maratha Matrimony" },
  { label: "96 Kuli Maratha Surname List PDF" },
  { label: "96 Kuli Maratha Vadhu Var Suchak Mandal Pune" },
  { label: "96k 96 Kuli Maratha images" },
  { label: "96 Kuli Maratha Brides Photos" },
  { label: "96 Kuli Maratha Caste" },
  { label: "96 Kuli Maratha Vadhu Var WhatsApp group link" },
  { label: "Second Marriage 45 age 96 Kuli Maratha Divorcee Brides" },
  { label: "96 Kuli Maratha Brides List" },
  { label: "96 Kuli Maratha is OBC or General" },
  { label: "96 Kuli Maratha Marriage" },
  { label: "96 Kuli Maratha Surname List with Gotra" },
  { label: "96 Kuli Maratha Vadhu" },
  { label: "96 Kuli Maratha Caste Category" },
  { label: "Anand Maratha 96 Kuli Maratha Brides" },
  { label: "96 Kuli Maratha Brides" },
  { label: "Gotra Marathi 96K 96 Kuli Maratha Surname List" },
  { label: "Maratha Vadhu" },
  { label: "Maratha Vadhu Var Suchak Kendra Nashik" },
  { label: "Maratha Vadhu Var Suchak Kendra Pune" },
  { label: "Maratha Vadhu Var" },
  { label: "Maratha Vadhu Var Suchak Kendra Kolhapur" },
  { label: "Maratha Vadhu Var Photo" },
  { label: "Maratha Vadhu Var Suchak Kendra" },
  { label: "Solapur Maratha Vadhu Var Suchak Whatsapp Group" },
  { label: "Free Maratha Vadhu Var Suchak Kendra" },
  { label: "Maratha Vadhu Var Suchak Mandal Pune" },
  { label: "Maratha Vadhu Var Suchak Kendra Solapur" },
  { label: "Maratha Vadhu photo Girl" },
  { label: "Maratha Vadhu Var Suchak Kendra Karad" },
  { label: "Maratha Vadhu Var Suchak kandra" },
  { label: "Maratha Vadhu photo" },
  { label: "Maratha Vadhu Var whatsapp group link" },
  { label: "96 Kuli Maratha Vivah Mandal" },
  { label: "Maratha Marriage Nashik" },
  { label: "Maratha Brides" },
  { label: "96 Kuli Maratha list surname" },
  { label: "List of 96 Kuli Maratha Surnames" },
  { label: "List of 96 Kuli Maratha" },
  { label: "Surname of 96 Kuli Maratha" },
  { label: "96 Kuli Maratha Names" },
  { label: "96 Kuli Maratha Surname" },
  { label: "Maratha 96 Kuli Surname" },
  { label: "96K Maratha surname list" },
  { label: "92 Kuli Maratha Surname List" },
  { label: "96 K Maratha surname list" },
  { label: "96k Maratha surname" },
  { label: "96 Kuli Maratha surname list in Marathi" },
  { label: "92 Kuli Maratha Surname List PDF" },
  { label: "96k Maratha surname list Marathi" },
  { label: "96 Kuli Maratha Surname List PDF Download" },
  { label: "96 Kuli Maratha Surname List in English" },
  { label: "96 Maratha surname list" },
  { label: "96 Kuli Maratha surname list in Marathi language" },
  { label: "96 Kuli Maratha surname list in Marathi PDF" },
  { label: "Maratha Surnames" },
  { label: "96 Kuli Maratha Surnames" },
  { label: "Kshatriya Maratha Surnames" },
  { label: "96 Kuli Maratha Surnames List" },
  { label: "Maratha Surnames List" },
  { label: "All 96 Kuli Maratha surnames" },
  { label: "96K Maratha surnames" },
  { label: "Kunbi Maratha surnames" },
  { label: "Top Maratha Surnames" },
  { label: "Kshatriya Maratha Surnames List" },
  { label: "List of 96 Kuli Maratha surnames in Marathi" },
  { label: "Maratha surnames in Maharashtra" },
  { label: "96 Maratha surnames" },
  { label: "Kshatriya Maratha surnames in Goa" },
  { label: "List of Maratha surnames in Maharashtra" },
  { label: "List of 96k Maratha surnames" },
  { label: "98 Kuli Maratha Surnames" },
  { label: "5 Kuli Maratha Surnames" },
  { label: "List of Maratha surnames" },
];

export default function KuliMarathaSurnameList() {
  const [openFAQ, setOpenFAQ] = useState<number | null>(null);

  return (
    <div className="bg-white">
      {/* Transparent Header */}
      <Header variant="transparent" />

      <HomeHeroSection
        title="96 कुळी मराठा वधू वरांसाठी"
        subtitle="महाराष्ट्रातील अग्रणी विवाहसंस्था"
        trackingSource="96_kuli_maratha_surname_list"
      />

      <HomeLandingSections />

      <HomeStoriesSection />

      <HomeCommunitySection />

      <HomeVoicesSection />

      <HomeAboutSection />

      {/* FAQ Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">
            Frequently Asked Questions
          </h2>
          <div className="max-w-4xl mx-auto">
            <div className="space-y-4">
              {[
                {
                  question: "How to join 96 Kuli Maratha Vadhu Var WhatsApp group link?",
                  answer: "No! Due to privacy policy, MarathiVadhuVarSuchak.com Marathi matrimony site does not have any WhatsApp group link to join."
                },
                {
                  question: "How to find 96 Kuli Maratha Vadhu Var WhatsApp number?",
                  answer: "First register free on MarathiVadhuVarSuchak.com Marathi matrimony site and after profile verification you can search for suitable profiles from you community."
                },
                {
                  question: "How will I get 96 Kuli Maratha Brides list PDF?",
                  answer: "If you want 96 Kuli Maratha Brides list online, then first register free through MarathiVadhuVarSuchak.com Marathi matrimony. After approval you can search for Maratha community brides list."
                },
                {
                  question: "Which is the best 96 Kuli Maratha Vadhu Var Suchak Mandal Mumbai?",
                  answer: "In Mumbai city, MarathiVadhuVarSuchak.com Marathi matrimony is the most trusted 96 Kuli Maratha Vadhu Var Suchak Mandal for free registration."
                },
                {
                  question: "How to search 96 Kuli Maratha Vadhu Var photos?",
                  answer: "You can search 96 Kuli Maratha Vadhu Var photos with profile on MarathiVadhuVarSuchak.com Marathi matrimony site. But first you have to register free here."
                },
                {
                  question: "How to get 96 Kuli Maratha Vadhu Var Contact Number?",
                  answer: "Visit the MarathiVadhuVarSuchak.com Marathi matrimony site to register free and after approval you can search for 96 Kuli Maratha Vadhu Var Contact Numbers for paid membership."
                },
                {
                  question: "What is the 96 Kuli Maratha Vadhu Var Phone Number?",
                  answer: "To get 96 Kuli Maratha Vadhu Var Phone Numbers, visit the MarathiVadhuVarSuchak.com Marathi matrimony site to register free."
                },
                {
                  question: "How much is the 96 Kuli Maratha Matrimony fees?",
                  answer: "The MarathiVadhuVarSuchak.com 96 Kuli Maratha Matrimony site annual fees are around Rs.2,000."
                },
                {
                  question: "How to search 96 Kuli Maratha brides in Mumbai?",
                  answer: "You can search 96 Kuli Maratha brides from Mumbai profiles on MarathiVadhuVarSuchak.com Marathi Matrimony site. But before that you have to register free."
                }
              ].map((faq, index) => (
                <div key={index} className="bg-white border border-gray-200 rounded-xl overflow-hidden shadow-sm">
                  <button
                    onClick={() => setOpenFAQ(openFAQ === index ? null : index)}
                    className="w-full px-6 py-4 text-left flex items-center justify-between hover:bg-gray-50 transition-colors"
                  >
                    <h3 className="text-lg font-semibold text-gray-900">
                      {faq.question}
                    </h3>
                    <svg
                      className={`w-5 h-5 text-gray-500 transition-transform duration-300 ${
                        openFAQ === index ? 'rotate-180' : ''
                      }`}
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  </button>
                  <div
                    className={`px-6 transition-all duration-300 ease-in-out ${
                      openFAQ === index ? 'pb-4 max-h-96 opacity-100' : 'max-h-0 opacity-0 overflow-hidden'
                    }`}
                  >
                    <div className="text-gray-600 leading-relaxed py-3">
                      <p className="mb-3">{faq.answer}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <CommunityMatrimonyServices
        title="96 Kuli Maratha matrimony for Maratha Community"
        items={communityServices}
      />

    </div>
  );
}

